__turbopack_context__.v({
  "wrapper": "index-module__bMtaLq__wrapper",
});
